<dx-data-grid #dataGrid id="dataGrid" [dataSource]="dataStore" [showBorders]="true" [columnAutoWidth]="true"
    [wordWrapEnabled]="true" [editing]="{ allowUpdating: false, allowAdding: false, allowDeleting: false }"
    [remoteOperations]="{ sorting: true, paging: true }">
    <dxi-column caption="Kunde" dataField="customer_name" dataType="string" alignment="left"
        [allowSorting]="true"></dxi-column>

    <dxi-column caption="Status" dataField="current_data_update" dataType="boolean" alignment="center"
        cellTemplate="updateStatusTemplate" [allowSorting]="false">
    </dxi-column>

    <div *dxTemplate="let data of 'updateStatusTemplate'">
                <i
                    [ngClass]="getClassForUpdateStatus(data)"
                    aria-label="Update status"
                    [title]="
                        data.value && data.data.last_update && isError(data.data.last_update_text) ? data.data.last_update_text :
                        data.value && data.data.last_update && !isError(data.data.last_update_text) && isOlderThanToday(data.data.last_update) ? 'Letzte Aktualisierung nicht mehr tagesaktuell' :
                        data.value && data.data.last_update && !isError(data.data.last_update_text) && !isOlderThanToday(data.data.last_update) ? 'Aktualisierung tagesaktuell' :
                        data.value ? 'Am aktualisieren...' : ''
                    "
                ></i>
    </div>
    <dxi-column caption="letzte Aktualisierungszeit" dataField="latest_duration" dataType="decimal" alignment="left"
        cellTemplate="durationTemplate" [allowSorting]="true">
        <div *dxTemplate="let data of 'durationTemplate'">
            {{ (data.value / 60) | number:'1.2-2' }} min
        </div>
    </dxi-column>
    <dxi-column caption="Min. Aktualisierungszeit" dataField="min_duration" dataType="decimal" alignment="left"
        cellTemplate="durationTemplate" [allowSorting]="true">
        <div *dxTemplate="let data of 'durationTemplate'">
            {{ (data.value / 60) | number:'1.2-2' }} min
        </div>
    </dxi-column>
    <dxi-column caption="Max. Aktualisierungszeit" dataField="max_duration" dataType="decimal" alignment="left"
        cellTemplate="averageDurationTemplate" [allowSorting]="true">
        <div *dxTemplate="let data of 'averageDurationTemplate'">
            {{ (data.value / 60) | number:'1.2-2' }} min
        </div>
    </dxi-column>
    <dxi-column caption="Letzte Aktualisierung erfolgreich beendet" dataField="last_update" dataType="datetime"
        alignment="left" cellTemplate="utcDateTemplate" [allowSorting]="true">
    </dxi-column>
    <div *dxTemplate="let data of 'utcDateTemplate'">
        {{ data.value | date: 'dd.MM.yyyy, HH:mm:ss' }}
    </div>

    <dxo-master-detail [enabled]="true" [autoExpandAll]="false" [template]="'detail'">
    </dxo-master-detail>
    <div *dxTemplate="let entry of 'detail'">
        <app-host-detail-grid [hostname]="entry.data.host"></app-host-detail-grid>
    </div>

    <dxo-paging [pageSize]="20"></dxo-paging>
    <dxo-pager [visible]="true" [showPageSizeSelector]="true" [allowedPageSizes]="[20, 50, 100]"></dxo-pager>
</dx-data-grid>